// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"247":"4dd6e153","324":"15a8cd83","371":"4da1b2ab","580":"528fb98c","641":"9816311f","799":"b8235f9f"}[chunkId] + ".css";
};